/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Value/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Value({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/ReferralsSection/Referrals/Referral/Kind/Template/Content/Value"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let profilePatientReferralTextValueValueData = fromData.useDataValue({ viewPath,
context: 'profile_patient_referral',
path: 'text_value',
})
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Value.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-5W6Xl': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Referral source"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 fontSize={dtTypographyFontsizeM}
 data="profile_patient_referral.text_value"
 text={profilePatientReferralTextValueValueData}
/>
</div>
{children}
</React.Fragment>)
}